<template>
    <b-container fluid class="no-padding bottom-padding">
        <div v-if='totalResults > itemsPerPage' class="vertical-padding">
            <b-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&laquo; Prev</b-button>
            <b-form-select @change='loadSelectedPage' v-model='currentPageNumberCopy' :options="pageNumberSelectOptions" v-if="totalPages > 1" style="width:auto;" class="form-control inline-auto-width" />
            <b-button variant='default' v-if="totalPages > 1" @click="loadNextPage">Next &raquo;</b-button>
            {{totalResults}}&nbsp;boards&nbsp;found
        </div>
        
        <div>
            <div :key='board.BoardID' v-for="board in boards">
             <b-button @click='navigateToBoard(board)' class='padded-button' size='sm' variant='default'><span class='glyphicon glyphicon-book'/> {{ board.Title }} &raquo;</b-button>
             {{ board.PatternsCount }} <span v-if='board.PatternsCount === 1'> draft</span><span v-if='board.PatternsCount > 1'> drafts</span>, ({{ board.OwnerName }})
            </div>
        </div>

        <div class="vertical-padding">
            <b-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&laquo; Prev</b-button>
            <b-form-select @change='loadSelectedPage' v-model='currentPageNumberCopy' :options='pageNumberSelectOptions' v-if="totalPages > 1" style="width:auto;" class="form-control inline-auto-width" />
            <b-button variant='default' v-if="totalPages > 1" @click="loadNextPage">Next &raquo;</b-button>
            {{totalResults}}&nbsp;boards&nbsp;found
        </div>
    </b-container>
</template>

<script>

import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import dataService from '../mixins/dataService.js'

export default {
    props: {
        itemsPerPage: {
            type: Number,
            required: true
        },
        currentPageNumber: {
            type: Number,
            required: true
        },
        boards: {
            type: Array,
            required: true
        },
        totalResults: {
            type: Number,
            required: true
        },
        onGoToPage: {
            type: Function,
            required: true
        }
    },
    mixins: [urlsService, mediaService, dataService],
    components: {
    },
    data() {
        return {
            pageNumberSelectOptions: [],
            currentPageNumberCopy: 0
        }
    },
    methods: {
        loadPageSelectOptions() {
            this.pageNumberSelectOptions = []
            let currentTotalPages = this.totalPages

            for (let c = 0; c < currentTotalPages; c++) {
                let prompt = 'Page ' + (c + 1) + ' of ' + currentTotalPages
                this.pageNumberSelectOptions.push({ value: c, text: prompt })
            }
        },
        loadPreviousPage() {
            if (this.currentPageNumber > 0) {
                this.onGoToPage(this.currentPageNumber - 1)
            }
        },
        loadNextPage() {
            if (this.currentPageNumber < this.totalPages-1) {
                this.onGoToPage(this.currentPageNumber + 1)
            }
        },
        loadSelectedPage(pageValue) {
            this.onGoToPage(pageValue)
        },
        navigateToBoard(board) {
            let sanitizedTitle = this.sanitizeUrlSegment(board.Title)
            this.$router.push({ name: 'DraftSearch', params: { searchType: 'board', bookOrCategoryId: board.BoardID, collectionTitle: sanitizedTitle } })
        }
    },

    watch: {
        totalResults: function(val) {
            this.loadPageSelectOptions()
        },
        currentPageNumber: function() {
            this.currentPageNumberCopy = this.currentPageNumber // this avoids binding dropdowns to a property, which causes errors when they change
        }
    },

    created: function() {
        this.currentPageNumberCopy = this.currentPageNumber // this avoids binding dropdowns to a property, which causes errors when they change
    },

    computed: {
        totalPages: function() {
            if (this.totalResults === 0) {
                return 0 // 0 results means 0 pages
            }
            let totalPagesCount = Math.floor((this.totalResults-1) / this.itemsPerPage) + 1  // 1 to 50 results means 1 pages, etc...
            let partialPageItemsCount = this.totalResults - (totalPagesCount * this.itemsPerPage)

            if (partialPageItemsCount > 0) {
                totalPagesCount++
            }
            return totalPagesCount
        }
    }
}
</script>

<style scoped>
    .padded-button {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        background-color: #f0f0f0;
    }

    .padded-button:hover {
        background-color: #dfdfdf;
    }
</style>



// WEBPACK FOOTER //
// src/components/BoardSearchResults.vue